// Hide $0.00 prices (e.g. free product options, zero-price variants) without
// removing them from the layout. Matches English ("$0.00", "$0.00 CAD") and
// French ("0,00 $", "0,00 $ CAD") formatting.
(function () {
  const ZERO_PRICE = /^(\$\s*0[.,]00|0[.,]00\s*\$)(\s*CAD)?$/;

  function hideZeroPrices() {
    document.querySelectorAll('.product-option, .price-item--regular').forEach((el) => {
      el.style.visibility = ZERO_PRICE.test(el.textContent.trim()) ? 'hidden' : '';
    });
  }

  // Cart notifications and variant changes replace prices after load, so
  // re-check on DOM changes (batched to once per frame).
  let scheduled = false;
  const observer = new MutationObserver(() => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      hideZeroPrices();
    });
  });

  hideZeroPrices();
  observer.observe(document.body, { childList: true, subtree: true, characterData: true });
})();

// Language/country switch on touch devices.
// Dawn's localization form closes itself when focus leaves it. On iOS Safari a
// tap on a link doesn't move focus, so the panel hides before the tap lands and
// the language never changes. Acting on pointerdown (which fires first) submits
// the form ourselves. Mouse input is left to Dawn's own click handler.
(function () {
  document.addEventListener(
    'pointerdown',
    (event) => {
      if (event.pointerType === 'mouse') return;
      const link = event.target.closest('localization-form a[data-value]');
      if (!link) return;
      const wrapper = link.closest('localization-form');
      const form = wrapper.querySelector('form');
      const input = wrapper.querySelector('input[name="locale_code"], input[name="country_code"]');
      if (!form || !input) return;
      event.preventDefault();
      input.value = link.dataset.value;
      form.submit();
    },
    true
  );
})();
